import { isLivingsHostname } from '../../shared/brand/platform-domains';

export const resolveIsLivings = () => {
    return isLivingsHostname(window.location.hostname);
};

export const adaptCMSContentForLivings = (content?: Record<string, any>) => {
    if (!content) {
        return content;
    }
    return JSON.parse(
        JSON.stringify(content)
            .replaceAll('Condo Asset Management', 'Livings')
            .replaceAll('verwaltung.condogroup.de', 'livings.de')
            .replaceAll('condogroup.de', 'livings.de')
            .replaceAll('CONDO', 'Livings')
            .replaceAll('HRB 159417', 'HRB 179042')
            .replaceAll('USt-ID: DE327459301', 'USt-ID: DE360371297'),
    );
};
